(() => {
  'use strict';
  if (window.__spStockAlternatives) return;
  window.__spStockAlternatives = true;
  const blocks = new Map();
  const modeFor = sku => {
    const parts = String(sku || '').toLowerCase().split('-');
    return parts.includes('d') ? 'print' : parts.includes('l') ? 'engrave' : 'plain';
  };
  const productData = async path => {
    const url = new URL(path, window.location.href);
    if (url.origin !== window.location.origin) throw new Error('Invalid product origin');
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Product unavailable');
    return response.json();
  };
  async function update(block, state, selectedId) {
    if (!block.isConnected) { blocks.delete(block); return; }
    const run = ++state.run;
    block.hidden = true;
    const cards = [...block.querySelectorAll('[data-alternative-card]')];
    cards.forEach(card => { card.hidden = true; });
    const form = document.getElementById(block.dataset.formId);
    const id = String(selectedId || form?.querySelector('[name="id"]')?.value || block.dataset.sourceVariant);
    const selection = state.config.variants.find(variant => variant.id === id);
    if (!selection) return;
    try {
      const source = await productData(block.dataset.sourceUrl);
      if (run !== state.run || !block.isConnected) return;
      const sourceVariant = source.variants.find(variant => String(variant.id) === id);
      if (!sourceVariant || sourceVariant.available) return;
      const matching = cards.filter(card => card.dataset.mode === selection.mode);
      const paths = [...new Set(matching.map(card => card.dataset.productUrl))];
      const products = new Map(await Promise.all(paths.map(async path => {
        try { return [path, await productData(path)]; } catch { return [path, null]; }
      })));
      if (run !== state.run || !block.isConnected) return;
      let visible = 0;
      matching.forEach(card => {
        const product = products.get(card.dataset.productUrl);
        const variant = product?.variants?.find(item => String(item.id) === card.dataset.variantId);
        if (!variant?.available || modeFor(variant.sku) !== selection.mode) return;
        const price = Number(variant.price);
        if (!Number.isFinite(price) || price <= 0) return;
        const currency = state.config.currency;
        card.querySelector('[data-alternative-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency }).format(price / 100);
        card.hidden = false;
        visible++;
      });
      block.hidden = visible === 0;
    } catch { if (run === state.run && block.isConnected) block.hidden = true; }
  }
  function scan(root) {
    const found = root.matches?.('[data-sp-alternatives]') ? [root] : [];
    root.querySelectorAll?.('[data-sp-alternatives]').forEach(block => found.push(block));
    found.forEach(block => {
      if (blocks.has(block)) return;
      try {
        const state = { config: JSON.parse(block.querySelector('[data-alternative-config]').textContent), run: 0 };
        blocks.set(block, state);
        update(block, state);
      } catch { block.hidden = true; }
    });
  }
  function refresh(event) {
    const selected = event?.detail?.variant?.id;
    blocks.forEach((state, block) => {
      if (!block.isConnected) { blocks.delete(block); return; }
      const sourceId = selected && state.config.variants.some(variant => variant.id === String(selected)) ? selected : null;
      update(block, state, sourceId);
    });
  }
  function start() {
    scan(document);
    document.addEventListener('variant:change', refresh);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('change', event => {
      if (event.target.matches?.('[name="id"],input[type="radio"][name*="product-form"],select[name*="product-form"]')) setTimeout(() => refresh(), 150);
    });
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches?.('[data-sp-alternatives]') || node.querySelector?.('[data-sp-alternatives]'))) scan(node);
    }))).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
